// Module
var code = "<h2 class=\"interiorSectionHeading\">Account Access Home</h2> <ul> <li> Get an at-a-glance view of your account.</li> <li> <strong>Make a payment.</strong></li> <li> Find your account number.</li> <li> Read important alerts or messages.</li> </ul> ";
// Exports
export default code;